<template>
  <div
    class="webcall"
    :class="{ 'webcall--large': largeWidth }"
  >
    <transition name="fade">
      <CurrentPositionText
        v-if="mapOverlay"
        :loading="currentPositionLoading"
        @handleClick="getCurrentPosition"
      />
    </transition>

    <div ref="map" class="webcall__map" />
    <!-- <v-btn @click="resetMap">resetMap</v-btn> -->
    <!-- <v-btn @click="getGeolocationPermission">getGeolocationPermission</v-btn> -->
    <Drawer
      @hideMapOverlay="hideMapOverlay"
      @toggleVisibility="getDrawerVisibility"
      @resetMap="resetMap"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CurrentPositionText from 'components/newWebCall/CurrentPositionText'
import Drawer from 'components/newWebCall/drawer'

export default {
  name: 'NewWebCallPage',
  computed: {
    $mapSelector () {
      return this.$refs.map
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage',
      currentPositionLoading: false,
      mapOverlay: true,
      largeWidth: true
    }
  },
  components: {
    CurrentPositionText,
    Drawer
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    getDrawerVisibility (val) {
      this.largeWidth = val
    },

    renderDefaultMap () {
      setTimeout(() => {
        if (!window.google || !this.$mapSelector) return this.renderDefaultMap()
        this.$gmaps.renderDefaultMap(this.$mapSelector)
      }, 1000)
    },

    async getGeolocationPermission () {
      const { state } = await navigator.permissions.query({ name: 'geolocation' })
      return state
    },

    async getCurrentPosition () {
      this.currentPositionLoading = true

      try {
        await this.$gmaps.getCurrentPosition()
        // TODO:
        this.hideMapOverlay()
      } catch (error) {
        this.showAlert({
          type: 'info',
          message: this.$t(`${this.namespace}.getCurrentPositionErrorMessage`)
        })
      }

      setTimeout(() => { this.currentPositionLoading = false }, 500)
    },

    hideMapOverlay () {
      this.mapOverlay = false
    },

    showMapOverlay () {
      this.mapOverlay = true
    },

    addCurrentPositionMarker () {
      setTimeout(async () => {
        const hasGrantedAccess = await this.getGeolocationPermission() === 'granted'
        if (hasGrantedAccess) {
          await this.getCurrentPosition()
          this.hideMapOverlay()
          return
        }

        this.showMapOverlay()
      }, 500)
    },

    resetMap () {
      // [TO DO WEBCALL]
      this.$mapSelector && this.$gmaps.resetMap(this.$mapSelector)
      this.addCurrentPositionMarker()
    }
  },
  mounted () {
    this.renderDefaultMap()
    this.addCurrentPositionMarker()
    const vContentElement = document.querySelector('.no-main-menu-from-v4 .v-content')
    if (vContentElement) {
      vContentElement.classList.add('web-call-container')
      vContentElement.classList.remove('v-content')
    }
  }
}
</script>

<style lang="scss" scoped>
.webcall {
  height: 100vh;
  position: relative;
  transition: width .16s;
  width: calc(100% - 60px);

  &.webcall--large {
    width: calc(100% - 360px);
  }
}

.webcall__map {
  height: 100%;
}
</style>

<style lang="scss">
.webcall__map {

  * {
    border: none !important;
  }
}

.application.theme--light.logged.route--webcall {

  .v-content {
    padding-top: 0 !important;
  }

  .corp-header {

    > .v-toolbar--fixed,
    .corp-header--mobile {
      display: none;
    }
  }
}
</style>
